import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class I18ConfigService {
  public selectedLanguage = new Subject<string>();
  constructor(private translate: TranslateService) {
    if (localStorage.getItem('lang')) {
      this.selectedLanguage.next(localStorage.getItem('lang'));
    }
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.selectedLanguage.next(event.lang);
    });
  }
  getDefaultLanguage() {
    let language = this.translate.getBrowserLang();
    this.translate.setDefaultLang(language);
    localStorage.setItem('lang', language);
    this.selectedLanguage.next(language);
    return language;
  }
  setLanguage(setLang) {
    this.translate.use(setLang);
    localStorage.setItem('lang', setLang);
  }
  getLanguage() {
    return this.translate.currentLang;
  }
  getCurrency(): string {
    return localStorage.getItem('currency') || 'INR';
  }
  setCurrency(currencyCode) {
    localStorage.setItem('currency', currencyCode);
  }
}
